// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"64201a47","199":"ca05af29","307":"293c6a18","444":"41b916b3","453":"d48df938","839":"40726a2d","965":"8dd0475e"}[chunkId] + ".chunk.js";
};